<template>
  <div>
    <div :class="$options.name">
      <div class="header">
        <img :src="publicUrl + '/logo.png'" width="50px" class="fasal-icon" />
        <span class="log-out" @click="logout">Log out</span>
      </div>
      <div class="app-container">
        <router-view :key="$route.path"></router-view>
      </div>
    </div>
    <div class="menu-label-icon">
      <div class="top-navigation-icon-container" @click="toggleSlider()">
        <img :src="publicUrl + '/sidebar/menu.png'" />
      </div>
      <div class="menu-label-container"></div>
    </div>
    <div id="sidebar-navigation" class="sidebar-collapsed sidebar-container" @click="toggleSlider()">
      <div class="close-button-container" title="Close sidebar"><img :src="publicUrl + '/sidebar/cancel.png'" /></div>
      <div class="sidebar-title">Menu</div>
      <div class="sidebar-content-container">
        <ul class="sidebar-content-list">
          <li v-for="item in routeList" :key="item.name" :class="currentRouteName == item.routeName ? 'active' : ''">
            <router-link :to="item.route">
              <div class="sidebar-item-container">
                <div class="sidebar-content">
                  <div class="feature-icon-container">
                    <img :src="publicUrl + (currentRouteName == item.routeName ? item.activeImg : item.iconImg)" />
                  </div>
                  <div class="title-description">
                    <div class="content-title">{{ item.name }}</div>
                    <div class="content-description">{{ item.description }}</div>
                  </div>
                </div>
                <div class="right-arrow-container">
                  <img
                    :src="
                      publicUrl +
                      (currentRouteName == item.routeName
                        ? '/sidebar/right-arrow-active.svg'
                        : '/sidebar/right-arrow-white.svg')
                    "
                  />
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "InApp",
    components: {},
    data() {
      return {
        publicUrl: process.env.PUBLIC_URL,
        routeList: [
          {
            activeImg: "/sidebar/manage-customer-active.svg",
            routeName: "dashboard",
            iconImg: "/sidebar/manage-customer.png",
            name: "Dashboard",
            description: "Device insights",
            route: "/dashboard"
          },
          {
            activeImg: "/sidebar/laptop-active.svg",
            routeName: "information-management",
            iconImg: "/sidebar/laptop.png",
            name: "Information Management",
            description: "Information management for device 360",
            route: "/information-management"
          },
          {
            activeImg: "/sidebar/laptop-active.svg",
            routeName: "sim-inventory",
            iconImg: "/sidebar/laptop.png",
            name: "Sim Inventory",
            description: "Sim Inventory for device 360",
            route: "/sim-inventory"
          },
          {
            activeImg: "/sidebar/laptop-active.svg",
            routeName: "device-compare",
            iconImg: "/sidebar/laptop.png",
            name: "Device Compare",
            description: "Device Compare for device 360",
            route: "/device-compare"
          },
          {
            activeImg: "/sidebar/laptop-active.svg",
            routeName: "device-troubleshooting",
            iconImg: "/sidebar/laptop.png",
            name: "Device Trouble Shooting",
            description: "Device TroubleShooting for device 360",
            route: "/device-troubleshooting"
          },
          {
            activeImg: "/sidebar/laptop-active.svg",
            routeName: "farm-automation-devices",
            iconImg: "/sidebar/laptop.png",
            name: "Farm Automation Devices",
            description: "Manage farm automation devices",
            route: "/farm-automation-devices"
          }
        ]
      }
    },
    computed: {
      currentRouteName() {
        return this.$route.name
      }
    },
    methods: {
      logout() {
        this.$store.commit("logout")
        this.$router.push("/login")
      },
      toggleSlider() {
        document.getElementById("sidebar-navigation").classList.toggle("sidebar-collapsed")
      },
      isActive(route) {
        if (this.route === route) return true
        return false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/settings/color";
  .router-link-active {
    text-decoration: none;
  }
  .InApp {
    padding: 1% 0 50px 0;
    height: 100vh;
    overflow: hidden;
  }
  .logo-text {
    font-size: 13px;
    padding-left: 5px;
  }
  .log-out {
    color: $color-primary;
    float: right;
    font-size: 13px;
    font-weight: 700;
    margin-top: 30px;
    cursor: pointer;
  }
  .icon-container {
    float: right;
    font-size: 16px;
    img {
      margin: 0 10px;
      cursor: pointer;
    }
    a {
      text-decoration: none;
    }
  }
  .fasal-icon {
    margin-left: calc(50% - 70px);
  }
  .bottom-bar {
    background: $color-primary;
    width: 100%;
    height: 50px;
    padding: 0 5%;
    position: fixed;
    bottom: 0;
    color: white;
    z-index: 10;
    padding-top: 18px;
    font-size: 12px;
    a {
      text-decoration: none;
      color: white;
    }
  }
  .header {
    width: 100%;
    padding: 10px 20px 10px 60px;
    border-bottom: 1px solid black;
    position: fixed;
    background: white;
    z-index: 10;
  }
  .app-container {
    height: calc(100vh - 1.5%);
    padding-left: 5%;
    padding-right: 5%;
    overflow: scroll;
    width: 100%;
    padding-top: 100px;
    padding-bottom: 60px;
    background: #fafbfc;
  }

  .sidebar-container {
    height: 100%;
    overflow: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    background: white;
    width: 100%;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
    transition: width 0.35s;
    z-index: 10001;
    &.sidebar-collapsed {
      .sidebar-content-container {
        opacity: 0;
        transition: display 0.35s;
      }
      width: 0;
    }
    button {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: none;
      outline: none;
      background: black;
      margin: 20px;
      cursor: pointer;
    }

    .close-button-container {
      float: right;
      padding: 15px;
      margin-top: 10px;
      img {
        width: 25px;
        height: 25px;
      }
    }
    .sidebar-title {
      font-size: 24px;
      margin-top: 20px;
      padding-left: 20px;
    }
    .sidebar-content-container {
      opacity: 1;
      -webkit-transition: all 0.85s ease-in-out;
      transition: all 0.85s ease-in-out;

      .sidebar-content-list {
        list-style: none;
        padding: 20px 0;
        li {
          cursor: pointer;
          padding: 0 20px;
          border-bottom: 1px solid #fafafa;
          &.active {
            background: #f5f5f5;
            padding: 0 20px;
            .content-title {
              color: #43a047;
            }
            .content-description {
              color: #43a047;
            }
          }
        }
        .sidebar-item-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .feature-icon-container {
            padding-right: 10px;
            img {
              height: 25px;
              width: 25px;
            }
          }
          .sidebar-content {
            padding: 10px 0;
            display: flex;
            align-items: center;
            .content-title {
              font-size: 16px;
              font-size: 16px;
            }
            .content-description {
              font-size: 12px;
              font-weight: 300;
            }
          }
          .right-arrow-container {
            img {
              width: 30px;
              height: 30px;
              padding: 5px;
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    .sidebar-container {
      max-width: 400px;
    }
  }

  .menu-label-icon {
    position: fixed;
    display: flex;
    align-items: center;
    top: 15px;
    z-index: 100;
    .menu-icon-container {
      color: #606060;
      width: 40px;
      height: 40px;
      margin-left: 5px;
      .menu-icon {
        fill: #606060;
      }
    }
  }

  .top-navigation-icon-container {
    padding: 18px 5px 18px 0;
    img {
      height: 25px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }
</style>
